import React, { Component } from "react"
import PropTypes from "prop-types"
import { translate } from "translate"
import { Col, Form, FormField, FormSelect, Row, Button, ButtonGroup } from "elemental"
import shop from "shop/shop"
import Pagination from "../Pagination/Pagination"
import "./Filter.scss"
import queryString from "querystring"

export default class Filter extends Component {

  constructor( props ) {
    super( props )
    this.onChange = props.onChange
    // sort: Artikelsortierung (mögliche Werte: article_nr,price,des,sort,map_id (ArtikelId) ,stock (Lagerbestand))
  }

  componentWillMount() {
    this.sortOptions = [
      {
        label: translate( "product.availability" ),
        value: "stock"
      },
      {
        label: translate( "product.articlenr" ),
        value: "article_nr"
      },
      {
        label: translate( "product.price" ),
        value: "price"
      }
      // ,
      // {
      //   label: translate( "product.popularity" ),
      //   value: "sort"
      // }
    ]

    if ( !shop.session ) {
      this.sortOptions.splice( 1, 1 )
    }

    this.pageCountOptions = [
      {
        label: "12",
        value: "12"
      },
      {
        label: "24",
        value: "24"
      },
      {
        label: "32",
        value: "32"
      },
      {
        label: "64",
        value: "64"
      }
    ]
  }

  componentWillReceiveProps( props ) {
    return props
  }

  handlePageSelect = ( page ) => {
    console.log( `page:`, page )
    this.onChange( { page } )
  }

  changeDirection = dir => {
    console.log( "DIRECTION", { dir } )
    this.onChange( { dir } )
  }

  render() {

    const query = queryString.parse( document.location.search.slice( 1 ) )
    const { dir = "desc" } = query
    return (
      <div className="filter">
        {/*<div><pre>{JSON.stringify(this.props, null, 2) }</pre></div>;*/}
        {(this.props.showFilter) ? <Row>
          <Col sm="1/4"
               md="1/3">
            {this.props.pagination ? <Pagination filter={this.props}
                                                 onChange={this.handlePageSelect}/> : null}
          </Col>

          <Col sm="1"
               md="1/4">
            <Form>
              <FormField label={translate( "shop.articles_per_site" )}
                         htmlFor="form-count">
                <FormSelect
                  value={String( this.props.pageSize )}
                  name="form-count"
                  options={this.pageCountOptions}
                  onChange={( pageSize ) => {
                    this.onChange( {
                      pageSize,
                      page: 1
                    } )
                  }}/>
              </FormField>
            </Form>
          </Col>


          <Col sm="1"
               md="1/4">
            <Form>
              <FormField label={translate( "shop.sort" )}
                         htmlFor="form-sort">

                <FormSelect
                  name="form-sort"
                  value={this.props.sort}
                  options={this.sortOptions}
                  onChange={( sort ) => {
                    this.onChange( { sort } )
                  }}/>

              </FormField>


            </Form>
          </Col>
          <Col sm="1"
               md="1/6">
            <FormField label={" "}
                       htmlFor="form-sort">

              <div className="tr">
                <ButtonGroup>
                  <Button title="Aufsteigend" onClick={() => this.changeDirection( "asc" )} type={`${dir === "asc"? "primary" : "default"}`}><i className="icon icon-up-dir"/></Button>
                  <Button title="Absteigend" onClick={() => this.changeDirection( "desc" )} type={`${dir === "desc"? "primary" : "default"}`}><i className="icon icon-down-dir"/></Button>
                </ButtonGroup>
              </div>
            </FormField>
          </Col>


        </Row> : null}

      </div>
    )
  }
}
Filter.defaultProps = {
  onChange:    () => {
  },
  currentPage: 1,
  pageSize:    6,
  pagination:  true,
  limit:       4,
  showFilter:  true,
}

Filter.propTypes = {
  onChange:    PropTypes.func,
  sort:        PropTypes.string,
  currentPage: PropTypes.number,
  pageSize:    PropTypes.number,
  plural:      PropTypes.string,
  singular:    PropTypes.string,
  total:       PropTypes.number,
  limit:       PropTypes.number,
  showFilter:  PropTypes.bool
}




// WEBPACK FOOTER //
// ./src/components/Filter/Filter.js